import * as HANDLERS from '@/helpers/types/handlers';

const inputEventsMixin = {
  mounted() {
    if (this.schema && this.schema.modelTitle) {
      this.schema[this.getComponentAttribute(this.schema.type)].title = this.model[this.schema.modelTitle];
    } else if (this.model && this.model[`${this.schema.model}_title`]) {
      this.schema[this.getComponentAttribute(this.schema.type)].title = this.model[`${this.schema.model}_title`];
    } else {
      return;
    }
  },

  methods: {
    changeEvents: async function (event) {
      if (event && (this.$store.getters['loading/lastCallElementToOnBlur'] === event?.target?.id)) {
        return;
      }

      if (event && event?.relatedTarget?.id && this.schema.actionEvent) {
        this.$store.dispatch('loading/callElementToOnBlur', event?.relatedTarget?.id);
      }

      if (this.schema.visible && this.schema.fill.length > 0)
        this.$store.dispatch('page/lookup', { fill: this.schema.fill, model: this.model, info: this.formOptions });

      if (this.schema.hasConditions) this.$store.dispatch('page/conditions', this.formOptions);

      if (this.schema.actionEvent) {
        const actions = await this.$store.getters['page/actions_scheme'](this.formOptions);
        let action = actions.items.find(x => x.name === this.schema.actionEvent);
        action.mode = this.formOptions.mode;

        this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.formOptions.page });
      }

      if ('serverValidation' in this.schema && Object.keys(this.schema.serverValidation).length) {
        this.$store.dispatch('page/serverValidate', {
          field: this.schema,
          model: this.model,
          info: this.formOptions,
          validation: this.schema.serverValidation
        });
      }
    },

    getComponentAttribute(type) {
      const types = {
        i4proTextField: 'attributesTextField',
        i4proSelect: 'attributesSelect',
        i4proCheckbox: 'attributes',
        i4proAutocomplete: 'attributesSelect',
        i4proCombobox: 'attributesSelect',
        i4proDatePickerDialog: 'attributesDatePicker',
        i4proDatePickerMenu: 'attributesTextField',
        i4proFileInput: 'attributesTextField',
        i4proPassword: 'attributesTextField',
        i4proRadioGroup: 'attributesRadioGroup',
        i4proRating: 'attributesRating',
        i4proSlider: 'attributes',
        i4proSwitch: 'attributes',
        i4proTextAreaConcat: 'attributesTextField',
        i4proTextFieldSearch: 'attributesTextField',
        i4proTextarea: 'attributesTextField',
        i4proTimePickerMenu: 'attributesTextField',
        i4proTimePickerDialog: 'attributesTextField',
        i4proTextFieldDecimal: 'attributesTextField'
      };

      return types[type];
    },

    // Por algum motivo desconhecido o sistema não está capturando o evento de enter para quebrar linha
    // O método abaixo é necessário para capturar o evento e adicionar uma quebra de linha manualmente
    onKeydown(event, selector) {
      if (event.key === 'Enter') {
        event.preventDefault(); // Previne o comportamento padrão do Enter

        const element = this.$refs[this.schema.model].$el.querySelector(selector);
        const start = element.selectionStart;
        const end = element.selectionEnd;

        // Se o valor for falsy, é necessário atribuir uma string vazia para que a quebra de linha seja adicionada
        if (!this.value) {
          this.value = '';
        }

        this.value = this.value.substring(0, start) + '\n' + this.value.substring(end);

        // Atualiza a posição do cursor
        this.$nextTick(() => {
          element.selectionStart = element.selectionEnd = start + 1;

          // Calcula a posição de rolagem correta
          const lineHeight = parseInt(window.getComputedStyle(element).lineHeight, 10);
          const cursorPosition = element.selectionStart;
          const lines = this.value.substring(0, cursorPosition).split('\n').length;
          const scrollPosition = (lines - 1) * lineHeight;

          // Ajusta a rolagem apenas se necessário
          if (element.scrollTop < scrollPosition) {
            element.scrollTop = scrollPosition;
          }
        });
      }
    }
  },

  watch: {
    value(newValue, oldValue) {
      if (newValue === '' && newValue !== oldValue) {
        this.value = null
      }
    }
  },
};

export default inputEventsMixin;
